exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile-page[data-v-694b1c7e]{padding:10px}", ""]);

// exports
